// extracted by mini-css-extract-plugin
export default {"linksWrapper":"Links_linksWrapper__qa+Lq","h4Title":"Links_h4Title__vULms","aTagLink":"Links_aTagLink__eGE+s"};